import { ProductCollectionSitemap } from '../../types';

type Props = {
  data: {
    productCollectionSitemap: ProductCollectionSitemap;
  };
};

export default (props: Props, { t }: any) => {
  const { data } = props;
  if (!data.productCollectionSitemap) {
    return {};
  }

  const title = t('meta', 'product-collection-sitemap.title', {
    title: data.productCollectionSitemap.name,
  });
  const description = t('meta', 'product-collection-sitemap.description', {
    title: data.productCollectionSitemap.name,
  });

  return {
    title,
    description,
    openGraph: [
      {
        key: 'title',
        content: title,
      },
      {
        key: 'desc',
        content: description,
      },
      {
        key: 'type',
        content: 'website',
      },
    ],
  };
};
